import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = {allot_batches_loading : true, allot_batches: '', allot_batches_error: false};

export function allotBatch(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ALLOT_BATCH:
        return {
            allot_batches_loading: true,
            allot_batches: '',
            allot_batches_error: false
        };
      case organisationConstants.RESPONSE_ALLOT_BATCH:
        return {
            allot_batches_loading: false,
            allot_batches: action.allot_batches,
            allot_batches_error: false
        };
      case organisationConstants.ERROR_ALLOT_BATCH:
        return { 
            allot_batches_loading: false,
            allot_batches: '',
            allot_batches_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/allotBatch.reducer.js